import classNames from "classnames";
import styles from "./styles.module.scss";
import { ScheduleCard } from "./types";
import { WarehouseSizeChange } from "./WarehouseSizeChange";
import { formatNumber } from "@/uiCore";
import { useAppState } from "@/modules/app/useAppContext";
import dayjs from "dayjs";

export const EventContent = ({ event }: { event: ScheduleCard }) => {
  const { currencySymbol } = useAppState();

  // Format the start and end times using dayjs
  const datetimeFormat = "h:mm A";
  const formattedStartTime = dayjs(event.start).format(datetimeFormat);
  const formattedEndTime = dayjs(event.end).format(datetimeFormat);
  const isExpired = dayjs(event.end).isBefore(dayjs());

  return (
    <div
      className={classNames(styles.event, {
        "al-cursor-default": event.type === "default",
      })}
      aria-label={`Schedule event ${event.id} ${event.type} ${event.status} from ${formattedStartTime} to ${formattedEndTime}`}
    >
      {/* Icon */}
      <WarehouseSizeChange event={event} />

      {/* Title */}
      <p
        className={`event-title ${event.type === "auto_resize" && !isExpired ? "auto-resize" : ""}`}
      >
        {formattedStartTime} - {formattedEndTime}
      </p>

      {/* Cluster Info */}
      {event.clusterMin && event.clusterMax && (
        <p
          className="event-cluster"
          aria-label={`Cluster count ${event.clusterMin} to ${event.clusterMax}`}
        >
          Cluster <strong>{event.clusterMin}</strong> -{">"} <strong>{event.clusterMax}</strong>
        </p>
      )}

      {/* Additional Info */}
      {event.savings && event.savings !== "0" && (
        <p className="event-savings">
          <strong>Savings:</strong> {currencySymbol}
          {formatNumber(event.savings) || event.savings}
        </p>
      )}
      {(event.type === "custom" || event.type === "default") && (
        <p className="event-savings">
          <strong>Savings:</strong> N/A
        </p>
      )}
    </div>
  );
};
